import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { countryPrefix } from 'src/app/pages/my-profile/phone-prefix';
import { ProfileService } from 'src/app/services/profile.service';
import { RegisterIfameComponent } from '../register-ifame/register-ifame.component';
import { RegisterPersonEmailComponent } from '../register-person/register-person-email/register-person-email.component';
import { Storage } from '@ionic/storage';
import { OverviewProjectService } from 'src/app/services/overview-project.service';
import { Profile, RegisterCompanyMainData } from 'src/app/shared/models/register.models';
import { ToastService } from '../../toast/toast.service';
import { ModalService } from '../../modal/modal.service';
import { PosthogService } from 'src/app/services/posthog.service';
import { DataLayerService } from 'src/app/services/data-layer.service';


@Component({
  selector: 'fun-register-company',
  templateUrl: './register-company.component.html',
  styleUrls: ['./register-company.component.scss']
})
export class RegisterCompanyComponent implements OnInit {

  @Output() public prevStepEvent = new EventEmitter<any>();
  @Output() public lastStepEvent = new EventEmitter<any>();
  @Output() public prevEvent = new EventEmitter<any>();
  @Output() public nextEvent = new EventEmitter<any>();
  @Output() public changeWayEvent = new EventEmitter<any>();
  @Output() public finishRegisterEvent = new EventEmitter<any>();
  @Output() public phoneNumberEvent = new EventEmitter<any>();
  @Output() public confirmCodeEmailEvent = new EventEmitter<any>();
  @Output() public confirmCodeEvent = new EventEmitter<any>();
  @Output() public confirmPhoneEvent = new EventEmitter<any>();
  @Output() public resendCodeEvent = new EventEmitter<any>();
  @Output() public fullInfoEvent = new EventEmitter<any>();
  @Output() public validateEmailEvent = new EventEmitter<any>();
  @Output() public changeEmailEvent = new EventEmitter<any>();
  @Output() public getAddressInfoEvent = new EventEmitter<any>();
  @Output() public downloadAppEvent = new EventEmitter<any>();
  @Output() public updateInfoEvent = new EventEmitter<any>();
  @Output() public emitDocumentEvent = new EventEmitter<any>();

  @Output() public updateCompanyAddressEvent = new EventEmitter<any>();
  @Output() public updateConstitutionDocumentEvent = new EventEmitter<any>();
  @Output() public updateRealOwnershipDocumentEvent = new EventEmitter<any>();
  @Output() public updateModel200DocumentEvent = new EventEmitter<any>();
  @Output() public updateIdentityPartnersDocumentsEvent = new EventEmitter<any>();
  @Output() public updateRLDataEvent = new EventEmitter<any>();
  @Output() public updateRLNationalityEvent = new EventEmitter<any>();
  @Output() public updateRLDocTypeEvent = new EventEmitter<any>();
  @Output() public updateRLIdentityDocumentEvent = new EventEmitter<any>();
  @Output() public updateProofAddressDocumentEvent = new EventEmitter<any>();
  @Output() public updateAcreditationCompanyChecksEvent = new EventEmitter<any>();
  @Output() public updateAcreditationCompanyDocEvent = new EventEmitter<any>();
  @Output() public acceptLWTermsEvent = new EventEmitter<any>();
  @Output() public finishEvent = new EventEmitter<any>();
  @Output() public signaturitAccreditEvent = new EventEmitter<any>();
  @Output() public continueInvestEvent = new EventEmitter<any>();
  @Output() public checkRefCodeEvent = new EventEmitter<any>();
  @Output() public removeModalEvent = new EventEmitter<any>();
  @Output() public profilegeneratedEvent = new EventEmitter<any>();

  @Input() registerStep: any;
  @Input() isMobileApp: any;
  @Input() info: RegisterCompanyMainData = {};
  @Input() list: any = {};
  @Input() editM: boolean;
  @Input() profile: Profile;
  @Input() towns: any;
  @Input() onlyAccredit: boolean;
  @Input() specificPartner: string;

  @ViewChild('registerIfameComponent', { static: false }) registerIfameComponent: RegisterIfameComponent;
  @ViewChild('registerPersonEmail', { static: false }) registerPersonEmail: RegisterPersonEmailComponent;

  public acceptConditions: boolean;
  public loading: boolean;
  public step: number;

  public moneyOutInfo;
  public skeletonActive = false;
  public sendXHR = 'primaryDark';
  public selectIsOpen = false;

  public userInfo: any = {};

  phoneNumber: any;
  isRegister: boolean;
  secondBtn: string;

  resended = false;
  countDown: string;
  isCountDowndEnd = false;
  activatedCountDoun = false;
  incompleteProfile = false;
  mailChanged = false;

  signaturitUrl: string;

  public wantToDownload = false;
  public registerForm: UntypedFormGroup;
  public selectForm: UntypedFormGroup;
  public formControlKeys = [];
  public errorMessages = {};
  public isSubmit = false;
  public errorAmount = false;
  public errorConcept = false;

  personalId: string;
  personalSpan: string;

  textMailV = this.translateService.instant('register.messages.congratulations_1');
  imageMailV = 10;
  textPhoneV = this.translateService.instant('register.messages.congratulations_2');
  imagePhoneV = 11;
  imageM = 4;

  text = `<h2>${this.translateService.instant('register.messages.data_uploaded_title')}</h2>
          <p>${this.translateService.instant('register.messages.data_uploaded_subtitle')}</p>`;

  textDocs = `<h2>${this.translateService.instant('register.messages.docs_uploaded_title')}</h2>
              <p>${this.translateService.instant('register.messages.docs_uploaded_subtitle')}</p>`;
  btnListDocs = [];
  imageDocs = 7;
  textIdentityDocs = `<h2>${this.translateService.instant('register.messages.docs_required_title')}</h2>
                      <p>${this.translateService.instant('register.messages.docs_required_subtitle')}</p>`;
  btnListIdentityDocs = [];
  imageIdentityDocs = 8;
  textPCAdvice = `<h2>${this.translateService.instant('register.messages.pc_advice_title')}</h2>
                  <p>${this.translateService.instant('register.messages.pc_advice_subtitle')}</p>`;
  imagePCAdvice = 8;
  btnListPCAdvice = [
    {
      index: 0,
      type: 'primaryDark',
      title: this.translateService.instant('register.btn.continue')
    }
  ];
  textFinish = `<h2>${this.translateService.instant('register.messages.finish_title')}</h2>
                <p>${this.translateService.instant('register.messages.finish_subtitle')}</p>
                <p>${this.translateService.instant('register.messages.finish_subtitle2')}</p>`;
  btnListFinish = [
    {
      index: 0,
      type: 'primaryDark',
      title: this.translateService.instant('register.btn.finish')
    }
  ];
  imageFinish = 6;

  RLDocsRequirements = [
    {
      title: this.translateService.instant('register.start.requirements_RL_docs.identity_doc')
    },
    {
      title: this.translateService.instant('register.start.requirements_RL_docs.address_doc'),
      text: this.translateService.instant('register.start.requirements_RL_docs.address_doc_subtitle')
    }
  ];

  companyDocsRequirements = [
    { title: this.translateService.instant('register.start.requirements_docs.constitution') },
    { title: this.translateService.instant('register.start.requirements_docs.RM_inscribe') },
    { title: this.translateService.instant('register.start.requirements_docs.model_200') },
    { title: this.translateService.instant('register.start.requirements_docs.titularityDNIs') }
  ];

  companyRequirements = [
    {
      title: this.translateService.instant('register.start.requirements_options.first_title'),
      text: this.translateService.instant('register.start.requirements_options.first_text')
    },
    {
      title: this.translateService.instant('register.start.requirements_options.second_title'),
      text: this.translateService.instant('register.start.requirements_options.second_text')
    },
    {
      title: this.translateService.instant('register.start.requirements_options.third_title'),
      text: this.translateService.instant('register.start.requirements_options.third_text')
    },
  ];

  hasConstitution1 = false;
  hasDocument1 = false;
  hasDocument2 = false;
  hasDocument3 = false;
  hasFrontDni = false;
  hasFrontNie = false;

  realOwnershipChecked = false;
  model200Checked = false;

  onBoardingIndex: number;
  emailIndex: number;
  emailCodeIndex: number;
  phoneIndex: number;
  phoneCodeIndex: number;
  passToPCAdviceIndex: number;
  contactPersonDataIndex: number;
  companyDataIndex: number;
  companyAddressIndex: number;
  welcomeIndex: number;
  contitutionDocsIndex: number;
  realOwnershipDocIndex: number;
  enterpriseModel200DocIndex: number;
  identityPartnerDocsIndex: number;
  RLStepsIndex: number;
  RLPersonalDataIndex: number;
  RLPersonalAddressIndex: number;
  RLNationalityIndex: number;
  RLDocumentTypeIndex: number;
  RLIdentityDocIndex: number;
  RLIdentityDocAdviceIndex: number;
  RLAddressDocIndex: number;
  RLSuccessIndex: number;
  acreditationConditionsIndex: number;
  acreditationDocIndex: number;
  acreditationSignaturitIndex: number;
  successCompleteRegisterIndex: number;
  iframeMeetingIndex: number;
  investMessageIndex: number;
  investFinishMessageIndex: number;
  okInvestMessageIndex: number;
  mailValidatedIndex: number;
  phoneValidatedIndex: number;
  identityPartnerSpecificDocsIndex: number;
  verifyEmailIndex: number;
  partnersIndex: number;
  partnersAddressIndex: number;
  partnersNationalityIndex: number;
  partnersSuccessIndex: number;
  shareHolderIndex: number;

  cb1 = false;
  cb2 = false;
  cb3 = false;
  cb4 = false;
  balanceDoc = false;
  profitsDoc = false;
  cnmvDoc = false;

  acreditationDocument: any;
  acceptPaymentEntity = false;
  uploadSimpleCopy = false;

  textM = this.translateService.instant('register.messages.no_data_1');
  textF = this.translateService.instant('register.messages.no_data_2');
  textI = this.translateService.instant('register.messages.congratulations_3');
  btnListM = [{
    type: 'primaryDark',
    index: 1,
    title: this.translateService.instant('register.messages.continue'),
  }];

  percent: number;
  stepNumber: number;
  refCode: string;
  emailPage = 'email';
  mangopayTerms = false;
  privacyTxt: string;
  termsTxt: string;
  hasPrivacyText = false;
  hasTermsTxt = false;
  specificDocumentOwner: any;

  textAcceptMail = this.translate.instant('register.validate_mail_msg');
  btnListAcceptMail = [{
    type: 'primaryDark',
    index: 1,
    title: this.translate.instant('register.messages.continue'),
  }];
  imageAcceptMail = 6;
  partners: any[] = [];
  partnersNumber: number = 0;
  partnersText = this.translate.instant('REGISTER.PARTNERS_ADDED');
  partnersBtnList = [{
    type: 'secondaryDark',
    index: 1,
    title: 'Añadir',
  }, {
    type: 'primaryDark',
    index: 2,
    title: 'Finalizar',
  }];

  @HostListener('document:keyup.enter', ['$event']) onKeyupEnterHandler(event: KeyboardEvent) {
    if (this.hasFooter() || this.step === this.successCompleteRegisterIndex || this.step === this.iframeMeetingIndex) {
      /* this.next(); */
      document.getElementById(this.personalId).click();
    } else {
      this.next();
    }
  }

  constructor(
    public chdRef: ChangeDetectorRef,
    private translateService: TranslateService,
    private profileService: ProfileService,
    private toastService: ToastService,
    private translate: TranslateService,
    private storage: Storage,
    private overviewService: OverviewProjectService,
    private modalService: ModalService,
    private posthogService: PosthogService,
    private dataLayerService: DataLayerService
  ) { }

  ngOnInit() {
    if (this.onlyAccredit && this.onlyAccredit !== undefined) {
      this.sendXHR = 'primaryDark-disabled';
      //this.changeAcreditationConditions();
      this.textFinish = this.translateService.instant('register.finish.step_accredit.title') + this.translateService.instant('register.finish.step_accredit.txt');
    }
    this.stepNumber = this.list.length - 2;
    this.percent = 100 / this.stepNumber;

    if (this.profile) {
      this.info = this.profile;
      this.cb1 = this.profile.accountAcreditation1000kActive;
      this.cb2 = this.profile.accountAcreditation2000kBusiness;
      this.cb3 = this.profile.accountAcreditation300kResources;
      this.cb4 = this.profile.accountAcreditationProfessionalAdvice;
    }
    this.step = 0;
    this.loading = false;
    this.secondBtn = 'secondary-disabled';

    if (this.list[0].name === 'shareHolder') {
      this.list.unshift(
        {name : 'partners'},
        {name : 'partnersAddress'},
        {name : 'partnersNationality'},
        {name : 'partnersSuccess'});

      this.list = this.list.map((item, i) => ({
        ...item,
        index: i
      }));
      this.step = 4;
    /*
        case 'partners':
          this.partnersIndex = element.index;
          break;
        case 'partnersAddress':
          this.partnersAddressIndex = element.index;
          break
        case 'partnersNationality':
          this.partnersNationalityIndex = element.index;
          break
        case 'partnersSuccess':
          this.partnersSuccessIndex = element.index;
          break
    */
    }

    if (this.list[0].name === 'phoneCode') {
      this.list.unshift({ name: 'phone', index: -1 });
      this.confirmPhoneEvent.emit();
    }

    if (this.profile && this.profile !== undefined && this.profile.mobile && this.profile.mobile !== undefined && this.profile.mobile !== '') {
      this.info.phone = this.profile.mobile;
    }

    if (this.list[0].name === 'emailCode') {
      this.editM = true;
      this.acceptConditions = true;
      this.list.unshift({ name: 'email', index: -1 });
    }

    if (this.editM === null || this.editM === undefined) {
      this.editM = false;
    }

    if (this.info !== undefined && this.info.prefix !== undefined && this.info.prefix !== null && this.info.prefix !== '') {
      let hasPrefix = false;
      this.info.phone = this.info.phone.toString();
      countryPrefix.forEach(element => {
        const prefixN = element.prefix.toString();
        const prefix = this.info.phone.substring(0, prefixN.toString().length);
        if (prefixN === prefix) {
          hasPrefix = true;
        }
      });
      if (!hasPrefix) {
        this.info.prefix = '34';
      }
    } else if (this.info === undefined) {
      this.info.prefix = '34';
    }

    this.list.forEach(element => {
      switch (element.name) {
        case 'onBoarding':
          this.onBoardingIndex = element.index;
          break;
        case 'email':
          this.emailIndex = element.index;
          break;
        case 'emailCode':
          this.emailCodeIndex = element.index;
          break;
        case 'phone':
          this.phoneIndex = element.index;
          break;
        case 'phoneCode':
          this.phoneCodeIndex = element.index;
          break;
        case 'passToPCAdvice':
          this.passToPCAdviceIndex = element.index;
          break;
        case 'contactPersonData':
          this.contactPersonDataIndex = element.index;
          break;
        case 'companyData':
          this.companyDataIndex = element.index;
          break;
        case 'companyAddress':
          this.companyAddressIndex = element.index;
          break;
        case 'welcome':
          this.welcomeIndex = element.index;
          break;
        case 'constitutionDocs':
          this.contitutionDocsIndex = element.index;
          break;
        case 'realOwnershipDoc':
          this.realOwnershipDocIndex = element.index;
          break;
        // case 'model200Doc':
        //   this.enterpriseModel200DocIndex = element.index;
        //   break;
        case 'identityPartnerDocs':
          this.identityPartnerDocsIndex = element.index;
          break;
        case 'identityPartnerSpecificDocs':
          this.identityPartnerSpecificDocsIndex = element.index;
          this.sendXHR = 'primaryDark-disabled';
          break;
        case 'RLSteps':
          this.RLStepsIndex = element.index;
          break;
        case 'RLPersonalData':
          this.RLPersonalDataIndex = element.index;
          break;
        case 'RLPersonalAddress':
          this.RLPersonalAddressIndex = element.index;
          break;
        case 'RLNationality':
          this.RLNationalityIndex = element.index;
          break;
        case 'RLDocumentType':
          this.RLDocumentTypeIndex = element.index;
          break;
        case 'RLIdentityDoc':
          this.RLIdentityDocIndex = element.index;
          break;
        case 'RLIdentityDocAdvice':
          this.RLIdentityDocAdviceIndex = element.index;
          break;
        case 'RLAddressDoc':
          this.RLAddressDocIndex = element.index;
          break;
        case 'RLSuccess':
          this.RLSuccessIndex = element.index;
          break;
        case 'acreditationConditions':
          this.acreditationConditionsIndex = element.index;
          break;
        case 'acreditationDoc':
          this.acreditationDocIndex = element.index;
          break;
        case 'acreditationSignaturit':
          this.acreditationSignaturitIndex = element.index;
          break;
        case 'successCompleteRegister':
          this.successCompleteRegisterIndex = element.index;
          break;
        case 'iframeMeeting':
          this.iframeMeetingIndex = element.index;
          break;
        case 'investMessage':
          this.investMessageIndex = element.index;
          break;
        case 'okInvestFinishMessage':
          this.okInvestMessageIndex = element.index;
          break;
        case 'investFinishMessage':
          this.investFinishMessageIndex = element.index;
          break;
        case 'phoneValidated':
          this.phoneValidatedIndex = element.index;
          break;
        case 'emailValidated':
          this.mailValidatedIndex = element.index;
          break;
        case 'verify_mail':
          this.verifyEmailIndex = element.index;
          break;
        case 'shareHolder':
          this.shareHolderIndex = element.index;
          break;
        case 'partners':
          this.partnersIndex = element.index;
          break;
        case 'partnersAddress':
          this.partnersAddressIndex = element.index;
          break
        case 'partnersNationality':
          this.partnersNationalityIndex = element.index;
          break
        case 'partnersSuccess':
          this.partnersSuccessIndex = element.index;
          break
      }
    });
    if (this.step === this.phoneIndex
      || this.step === this.contitutionDocsIndex
      || this.step === this.realOwnershipDocIndex
      //|| this.step === this.enterpriseModel200DocIndex
      || this.step === this.identityPartnerDocsIndex
      || this.step === this.RLIdentityDocIndex
      || this.step === this.RLAddressDocIndex
      || this.step === this.acreditationDocIndex
      || this.identityPartnerSpecificDocsIndex
      || this.step === this.partnersIndex
      || this.step === this.partnersAddressIndex
      || this.step === this.partnersNationalityIndex) {
      this.sendXHR = 'primaryDark-disabled';
    }
    if (this.step !== this.onBoardingIndex
      && this.step !== this.emailIndex
      && this.step !== this.emailCodeIndex
      && this.step !== this.phoneIndex
      && this.step !== this.phoneCodeIndex
      && this.step !== this.contactPersonDataIndex
      && this.step !== this.companyDataIndex
      && this.step !== this.companyAddressIndex
      && this.step !== this.mailValidatedIndex
      && this.step !== this.phoneValidatedIndex) {
      this.secondBtn = 'secondary';
    }
    this.getIdBtnName();
    if (this.step === 0) {
      this.secondBtn = 'secondary-disabled';
    }
    //this.getPrivacyPolicy();
    //this.getTermsPolicy();
    this.chdRef.detectChanges();
  }

  async getPrivacyPolicy() {
    const privacy = this.translate.currentLang === 'es' ? 'privacidad' : 'privacy';
    this.profileService.getText(privacy, this.translate.currentLang).subscribe(value => {
      this.privacyTxt = value.content;
      this.hasPrivacyText = true;
      this.chdRef.detectChanges();
    }, error => {
      this.privacyTxt = '<p>Versión 2.0 - 31 de octubre de 2019</p>\n<br>\n<p>Esta es nuestra Política de Privacidad (en adelante, la “Política”) que es aplicable al tratamiento de datos personales que realizamos en\n          FUNDEEN SPAIN, P.F.P., S.L., (en adelante, “Fundeen”) a través de nuestra página web <a href=\"www.fundeen.com\">www.fundeen.com </a> (en adelante, la “Web”).\n        </p>\n        <p>Fundeen es una plataforma autorizada y supervisada por la Comisión Nacional del Mercado de Valores (en adelante, la “CNMV”)\n          conforme a lo establecido en la Ley 5/2015, de 27 de abril, de fomento a la financiación empresarial,\n          e inscrita con el número 27 en el Registro de Plataformas de Financiación Participativa de la CNMV.</p>\n          <p>Fundeen  pretende  democratizar  la  inversión  en  proyectos  de  energía  renovable  y  hacerla accesible a cualquier ciudadano.</p>\n          <p>En Fundeen  consideramos  imprescindible  proteger  la  privacidad  y  la  seguridad  de  tus  datos personales, tal como describimos en esta Política.</p>\n          <h2>1.\tDATOS DE CONTACTO</h2>\n          <p>FUNDEEN SPAIN, P.F.P., S.L., sociedad española debidamente inscrita en el Registro Mercantil de Ávila al tomo 175, libro 133, folio 1, sección 8ª, hoja AV-6832, inscripción 2ª.</p>\n          <ul>\n            <li>»\tDirección: Plaza de Santa Teresa de Jesús, 14, 1º-1, 05001, Ávila</li>\n            <li>»\tNIF: B-87884896</li>\n            <li>»\tEmail de contacto: <a href=\"href=mailto:privacidad@fundeen.com\">privacidad@fundeen.com</a></li>\n          </ul>\n          <p>En cualquier caso, puedes contactar con nuestro DELEGADO/A DE PROTECCIÓN DE DATOS en la dirección de correo electrónico indicada arriba.</p>\n          <h2>2. NORMATIVA  APLICABLE  Y  PRINCIPIOS  DE  PROTECCIÓN  DE  DATOS PERSONALES</h2>\n          <p>La recogida de datos personales, el tratamiento y su utilización posterior por Fundeen está sujeta al Reglamento UE 2016/671 General de Protección de Datos,\n            de fecha 27 de abril de 2016 (en adelante, por sus siglas “RGPD”), y la Ley Orgánica 3/2018, de 5 de diciembre,\n            de Protección de Datos Personales y garantía de los derechos digitales (en adelante, la “LOPDyGDD”).</p>\n          <p>En Fundeen tratamos tus datos personales con arreglo a los siguientes principios (establecidos en dicha normativa): </p>\n          <ul>\n            <li>»\tTratar los datos con licitud, lealtad y transparencia.</li>\n            <li>»\tTratar los datos de forma limitada a la finalidad por la que fueron recogidos.</li>\n            <li>»\tMinimización de datos: tratar datos adecuados, pertinentes y limitados a lo necesario.</li>\n            <li>»\tExactitud: tratar datos exactos y, cuando es necesario, actualizados.</li>\n            <li>»\tLimitación del plazo de conservación: no conservar datos más del tiempo necesario para los fines requeridos.</li>\n            <li>»\tIntegridad y confidencialidad, garantizando un nivel de seguridad adecuado.</li>\n          </ul>\n          <h2>3. ¿QUÉ BASES JURÍDICAS NOS PERMITEN TRATAR TUS DATOS PERSONALES?</h2>\n          <p>En  Fundeen solo  recogemos  y  tratamos  tus  datos  personales  cuando  se  da  alguna  de  las situaciones expuestas a continuación:</p>\n          <ul>\n            <li>(a) Tenemos tu consentimiento explícito.</li>\n            <li>(b) Es necesario para prestarte nuestros servicios de inversión en proyectos de energía\n              renovable en base al cumplimiento y ejecución de los contratos necesarios.</li>\n            <li>(c) Para dar cumplimiento a nuestros intereses legítimos para fines estadísticos y/o cuando nos consultas o solicitas un servicio.</li>\n            <li>(d)\tEn caso de que debamos cumplir con nuestras obligaciones legales.</li>\n          </ul>\n          <h2>4. ¿PARA QUÉ UTILIZAMOS TUS DATOS PERSONALES?</h2>\n          <p>Fundeen únicamente utiliza tus datos personales para las siguientes finalidades:</p>\n          <ul>\n            <li>» Prestar nuestros servicios consistentes en ayudar y asistir a particulares a poder invertir en proyectos de energías renovables.</li>\n            <li>» Contestar a una solicitud de información y/o comunicación, incluyendo este caso el remitir información solicitada y relevante.</li>\n            <li>» Envío –previa autorización– de comunicaciones comerciales y promocionales por los medios facilitados.</li>\n            <li>» Cumplir con las leyes y normas aplicables. Por ejemplo, cuando necesitamos tratar tus datos para realizar verificaciones\n              en cumplimiento de las normas sobre prevención del blanqueo de capitales y de la financiación del terrorismo.</li>\n            <li>» Realización de estadísticas para conocer el tráfico y utilización de la Web, así como focalizar la información publicitaria de acuerdo con sus intereses. </li>\n            <li>» Tratamiento automático y de información agregada para procurar que la información que te enviamos es acorde a tus intereses.</li>\n          </ul>\n          <h2>5. ¿QUÉ DATOS PERSONALES RECABA FUNDEEN?</h2>\n          <p>Un dato personal es cualquier información alfanumérica, gráfica, fotográfica, acústica o de cualquier otro tipo que pueda ser\n            identificada o vinculada a una persona física concreta.\n          </p>\n          <p>En este sentido, la recogida de datos personales se realizará a través de los formularios presentes en la propia Web o a través de\n              cualquier otro medio de contacto: chat habilitado en la Web, correo electrónico o telefónicamente.\n          </p>\n          <p>Fundeen te informará en todo momento de la cumplimentación de datos obligatorios para el completo funcionamiento de la aplicación y\n            para el cumplimiento de las obligaciones legales. En caso de no facilitarlos, únicamente se podrá navegar por la Web, pero podrás operar.\n          </p>\n          <p>En virtud de lo expuesto, la información de carácter personal que se va a recabar será la siguiente:</p>\n          <ul>\n            <li>\n              <span>» Datos identificativos:</span>\n              <ul>\n                <li>o\tCorreo electrónico</li>\n                <li>o Nombre y apellidos</li>\n                <li>o Fecha de nacimiento</li>\n                <li>o Número de teléfono</li>\n                <li>o Sexo</li>\n                <li>o Nacionalidad</li>\n                <li>o Domicilio fiscal</li>\n                <li>o Documento de identidad: DNI, NIE o Pasaporte</li>\n              </ul>\n            </li>\n            <li>» Datos financieros necesarios o derivados de la ejecución de nuestros servicios.</li>\n            <li>» Datos personales relacionados con sus intereses o preferencias de inversión.</li>\n            <li>» En su caso, datos de actividad en nuestra página para fines estadísticos.</li>\n          </ul>\n          <h2>6. ¿CON QUIÉN COMPARTIMOS TUS DATOS PERSONALES?</h2>\n          <p>Tus datos personales únicamente serán compartidos con nuestros proveedores a fin de poder\n            prestar nuestros servicios, cumpliendo siempre con las medidas de seguridad técnicas y organizativas necesarias.\n          </p>\n          <p>En caso de que los datos sean alojados o tratados fuera de la Unión Europea o el Espacio Económico Europeo,\n            lo haremos siempre garantizando la plena seguridad de estos por medio de mecanismos legales y las medidas de seguridad técnicas oportunas.\n          </p>\n          <p>En Fundeen no cederemos tus datos con otras entidades si no disponemos de tu consentimiento explícito\n            (en cuyo caso lo haríamos únicamente para los fines que nos indiques expresamente), o si es necesario para cumplir con obligaciones legales.\n          </p>\n          <h2>7.MEDIDAS DE SEGURIDAD Y CONSERVACIÓN DE LOS DATOS</h2>\n          <p>Fundeen ha adoptado todas las medidas técnicas y de organización para garantizar la confidencialidad, integridad, disponibilidad y\n            cumplimiento de la regulación, teniendo en cuenta el estado de la técnica y el coste repercutido respecto al riesgo potencial.\n            Además, se compromete a seguir actualizando y mejorando continuamente, a fin de mantener una calidad y seguridad de servicio acorde a lo esperado.\n          </p>\n          <p>Los datos se conservarán durante el tiempo estrictamente necesario para cumplir con las finalidades del tratamiento y cumplir con nuestras obligaciones legales.</p>\n          <p>Tus datos serán conservados hasta el momento de tu baja definitiva como usuario\n            registrado de Fundeen, así como el tiempo necesario para el cumplimiento de nuestras obligaciones legales.\n          </p>\n          <p>En caso de que no seas un usuario registrado, conservamos los datos durante el tiempo necesario\n            para para mantenerte informado y atender tus consultas y peticiones, así como para cumplir con nuestras obligaciones legales.\n          </p>\n          <p>\n            También conservamos información agregada con finalidades estadísticas, asegurándonos que no se pueda\n            identificar a los usuarios registrados, respetando su privacidad.\n          </p>\n          <h2>8. EJERCICIO DE LOS DERECHOS</h2>\n          <p>Podrás ejercer en cualquier momento tus derechos de privacidad y de forma gratuita según establece la normativa aplicable, tales como:</p>\n          <ul>\n              <li>(1)\tConocer qué datos de carácter personal han sido recabados y tratados por Fundeen, para qué finalidades y con qué terceros destinatarios se comparten dichos datos.</li>\n              <li>(2)\tObtener una copia de dichos datos (la segunda y sucesivas copias pueden generar costes administrativos).</li>\n<li>(3)\tSolicitar la rectificación de los datos personales inexactos que te conciernan, o a que se completen aquellos que sean incompletos.</li>\n<li>(4)\tSolicitar la supresión de los datos personales que te conciernan cuando dejen de ser necesarios en relación con los fines para los que fueron recogidos.</li>\n              <li>(5)\tSolicitar la limitación del tratamiento de tus datos personales, en tanto se verifica su potencial inexactitud y demás supuestos previstos en la normativa aplicable.</li>\n              <li>(6)\tEl derecho a que tus datos personales sean transmitidos a otra empresa en un formato común estructurado (derecho a la portabilidad de los datos).</li>\n              <li>(7)\tEl derecho a oponerse al tratamiento de tus datos personales por parte de Fundeen.</li>\n          </ul>\n          <p>Para ejercer cualquiera de estos derechos deberás dirigirte al departamento de privacidad de Fundeen mediante correo electrónico o por correo postal a las\n            direcciones indicadas en el apartado 1 de esta Política. Para poder ejecutar la petición es necesaria la siguiente información:</p>\n          <ul>\n              <li>»\tNombre y apellidos.</li>\n              <li>»\tPetición o derecho que se quiere solicitar.</li>\n              <li>»\tCanal de respuesta. Si no se incluye se responderá por el mismo medio de contacto original.</li>\n              <li>»\tDocumentos acreditativos que sean necesarios.</li>\n          </ul>\n          <p>Fundeen se compromete a tratar todas las peticiones con la mayor celeridad y seguridad posible, en cumplimiento de las leyes aplicables.</p>\n          <p>Fundeen se reserva el derecho de solicitar la documentación necesaria para verificar la identidad del interesado y la legitimidad de la petición.</p>\n          <p>También tienes derecho a presentar una reclamación ante una autoridad de control competente: <a href=\"www.aepd.es\">www.aepd.es</a>.</p>\n          <h2>9.\tVERACIDAD</h2>\n          <p>Es tu responsabilidad proveer datos actuales, correctos y fehacientes a fin de que Fundeen\n            pueda prestar sus servicios. Fundeen te podrá solicitar en cualquier momento los documentos\n             necesarios para comprobar la veracidad de dichos datos y se exime de responsabilidad en caso de que se incumpla tal obligación.</p>\n          <h2>10.\tMODIFICACIONES</h2>\n          <p>Fundeen podrá en cualquier momento revisar y modificar esta Política, bien para adaptarla a la\n             normativa o por recomendaciones de la Agencia Española de Protección de Datos (AEPD). </p>\n          <p>En cualquier caso, se comunicará de forma transparente, y quedará reflejado en esta Política.</p>"'
      this.hasPrivacyText = true;
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  async getTermsPolicy() {
    this.profileService.getText('lemonway-terms', this.translate.currentLang).subscribe(value => {
      this.termsTxt = value.content;
      this.hasTermsTxt = true;
      this.chdRef.detectChanges();
    }, error => {
      this.termsTxt = '';
      this.hasTermsTxt = true;
    });
    this.chdRef.detectChanges();
  }

  goIframe(completed?: string) {
    if (completed !== 'ok') {
      this.incompleteProfile = true;
    }
    if (this.step + 1 === this.list.length) {
      this.finishEvent.emit();
    } else {
      this.step = this.iframeMeetingIndex;
    }
    this.chdRef.detectChanges();
  }

  goFinish() {
    if ((this.step === this.RLDocumentTypeIndex
      || this.step === this.RLIdentityDocIndex)
      && this.info.identityDocumentPassportRepresentative
      && this.info.identityDocumentFrontPassportRepresentative
      && this.RLIdentityDocAdviceIndex) {
      this.step = this.RLIdentityDocAdviceIndex;
      this.sendXHR = 'primaryDark';
    } else if (this.step === this.companyAddressIndex || this.step === this.identityPartnerDocsIndex || this.step === this.RLAddressDocIndex) {
      this.sendXHR = 'primaryDark';
      this.finish();
    } else {
      this.finish();
    }
    this.chdRef.detectChanges();
  }

  setTitleButton() {
    if (this.step === this.successCompleteRegisterIndex && this.step + 1 === this.iframeMeetingIndex) {
      return this.translateService.instant('register.btn.talk');
    }
    return this.translateService.instant('register.btn.continue');
  }

  next() {
    if (this.step === this.phoneIndex) {
      this.confirmPhoneEvent.emit();
    }
    if (this.step === this.phoneCodeIndex) {
      this.confirmCodeEvent.emit(this.info.code);
    }
    if (this.step === this.emailCodeIndex) {
      this.confirmCodeEmailEvent.emit(this.info.code);
    }
    if (this.step === this.identityPartnerSpecificDocsIndex) {
      this.updateSpecificDocumentOwner();
    }
    if (this.step === this.emailIndex) {
      if (!this.editM) {
        const payload = {
          profileType: 2,
          acceptConditions: this.info.acceptConditions,
          acceptOffers: this.info.acceptOffers,
          email: this.info.email,
          pwd: this.info.pwd,
          referredPromotionalCode: this.refCode
        };
        this.validateEmailEvent.emit(payload);
        this.getConditions(false);
      } else {
        if (this.mailChanged) {
          const params = {
            email: this.info.email,
            password: this.info.pwd
          };
          this.changeEmailEvent.emit(params);
        }
      }
    }
    if (this.step === this.companyDataIndex) {
      this.generateProfile();
    }
    if (this.step === this.companyAddressIndex) {
      this.updateCompanyAddressEvent.emit(this.info);
    }
    if (this.step === this.contitutionDocsIndex) {
      const arrDocs = [this.info.constitutionDocument1,
      this.info.constitutionDocument2];
      this.updateConstitutionDocumentEvent.emit(arrDocs);
      this.hasConstitution1 = false;
    }
    if (this.step === this.realOwnershipDocIndex) {
      const arrDocs = [this.info.realOwnershipDocument];
      this.updateRealOwnershipDocumentEvent.emit(arrDocs);
    }
    // if (this.step === this.enterpriseModel200DocIndex) {
    //   const arrDocs = [this.info.enterpriseModel200];
    //   this.updateModel200DocumentEvent.emit(arrDocs);
    // }
    if (this.step === this.identityPartnerDocsIndex) {
      const arrDocs = [this.info.identityDocumentPartner1,
      this.info.identityDocumentPartner2,
      this.info.identityDocumentPartner3,
      this.info.identityDocumentPartner4];
      this.updateIdentityPartnersDocumentsEvent.emit(arrDocs);
      this.hasDocument1 = false;
      this.hasDocument2 = false;
      this.hasDocument3 = false;
    }
    if (this.step === this.RLPersonalDataIndex) {
      this.updateRLDataEvent.emit(this.info);
    }
    if (this.step === this.RLNationalityIndex) {
      this.updateRLNationalityEvent.emit(this.info);
    }
    if (this.step === this.RLDocumentTypeIndex) {
      this.updateRLDocTypeEvent.emit(this.info);
    }
    if (this.step === this.RLIdentityDocIndex) {
      this.updateRLIdentityDocumentEvent.emit(this.info);
      this.hasFrontDni = false;
      this.hasFrontNie = false;
    }
    if (this.step === this.RLAddressDocIndex) {
      this.updateProofAddressDocumentEvent.emit(this.info);
    }
    if (this.step === this.acreditationConditionsIndex) {
      this.updateAcreditationCompanyChecksEvent.emit(this.info);
    }
    if (this.step === this.acreditationDocIndex) {
      let typeDoc;
      if (this.balanceDoc) { typeDoc = 1; }
      if (this.profitsDoc) { typeDoc = 2; }
      if (this.cnmvDoc) { typeDoc = 3; }
      const model = {
        type: typeDoc,
        file: this.acreditationDocument
      };
      this.updateAcreditationCompanyDocEvent.emit(model);
    }
    if (this.step === this.RLIdentityDocIndex) {
      if (this.info.identityDocumentTypeRepresentative === 3
        && (this.info.identityDocumentFrontNieRepresentative === null
          || this.info.identityDocumentFrontNieRepresentative === undefined
          || this.info.identityDocumentFrontNieRepresentative === '')) {
        this.info.identityDocumentTypeRepresentative = 2;
        this.step = this.RLDocumentTypeIndex - 1;
      } else if (this.info.identityDocumentTypeRepresentative === 2
        && (this.info.identityDocumentFrontPassportRepresentative === null
          || this.info.identityDocumentFrontPassportRepresentative === undefined
          || this.info.identityDocumentFrontPassportRepresentative === '')) {
        this.info.identityDocumentTypeRepresentative = 3;
        this.step = this.RLDocumentTypeIndex - 1;
      } else {
        //this.step = this.RLAddressDocIndex - 1;
      }
    }
    if (this.step === this.RLPersonalAddressIndex) {
      this.loading = true;
      const model = {
        addressRepresentative: this.checkEmptyValue(this.info.addressRepresentative) ? null : this.info.addressRepresentative,
        postalCodeRepresentative: this.checkEmptyValue(this.info.postalCodeRepresentative) ? null : this.info.postalCodeRepresentative,
        cityRepresentative: this.checkEmptyValue(this.info.cityRepresentative) ? null : this.info.cityRepresentative,
        internationalCityRepresentative: this.checkEmptyValue(this.info.internationalCityRepresentative) ? null : this.info.internationalCityRepresentative,
        regionRepresentative: this.checkEmptyValue(this.info.taxRegregionRepresentative) ? null : this.info.taxRegregionRepresentative,
        internationalRegionRepresentative: this.checkEmptyValue(this.info.internationalRegionRepresentative) ? null : this.info.internationalRegionRepresentative,
      }
      this.updateData(model);
    }
    this.step++;
    if (this.step === this.passToPCAdviceIndex) {
      if (this.detectOS() !== 'iOS' && this.detectOS() !== 'Android') {
        this.step++;
      }
    }
    if (this.step === this.phoneIndex
      || this.step === this.contitutionDocsIndex
      || this.step === this.realOwnershipDocIndex
      //|| this.step === this.enterpriseModel200DocIndex
      || this.step === this.identityPartnerDocsIndex
      || this.step === this.RLIdentityDocIndex
      || this.step === this.RLAddressDocIndex
      || this.step === this.acreditationDocIndex
      || this.step === this.partnersIndex
      || this.step === this.partnersAddressIndex
      || this.step === this.partnersNationalityIndex) {
      this.sendXHR = 'primaryDark-disabled';
    }
    if (this.step !== this.onBoardingIndex
      && this.step !== this.emailIndex
      && this.step !== this.emailCodeIndex
      && this.step !== this.phoneIndex
      && this.step !== this.phoneCodeIndex
      && this.step !== this.contactPersonDataIndex
      && this.step !== this.companyDataIndex
      && this.step !== this.companyAddressIndex
      && this.step !== this.mailValidatedIndex
      && this.step !== this.phoneValidatedIndex) {
      this.secondBtn = 'secondary';
    }

    if (this.step === this.acreditationDocIndex) {
      if (!this.checkAcreditationChecked()) {
        this.step = this.successCompleteRegisterIndex;
        this.sendXHR = 'primaryDark';
      }
    }

    if (this.step === this.investFinishMessageIndex) {
      this.checkFullProfile();
    }
    this.nextEvent.emit(this.step);
    this.userInfo.info = this.info;
    this.getIdBtnName();
    this.controlProgressBarSize(true);
    if (this.step === this.list.length) {
      this.finishEvent.emit();
    }
    this.chdRef.detectChanges();
  }
  prev() {
    this.resended = false;
    this.step--;
    if (this.step !== this.onBoardingIndex
      && this.step !== this.emailIndex
      && this.step !== this.emailCodeIndex
      && this.step !== this.phoneIndex
      && this.step !== this.phoneCodeIndex
      && this.step !== this.contactPersonDataIndex
      && this.step !== this.companyDataIndex
      && this.step !== this.companyAddressIndex
      && this.step !== this.mailValidatedIndex
      && this.step !== this.phoneValidatedIndex) {
      this.secondBtn = 'secondary';
    } else {
      this.secondBtn = 'secondary-disabled';
    }
    if (this.step === 0) {
      this.secondBtn = 'secondary-disabled';
    }
    if (this.step === this.onBoardingIndex
      || this.step === this.passToPCAdviceIndex
      || this.step === this.welcomeIndex
      //|| this.step === this.RLStepsIndex
      || this.step === this.RLIdentityDocAdviceIndex
      || this.step === this.RLSuccessIndex
      || this.step === this.successCompleteRegisterIndex
      || this.step === this.investMessageIndex
      || this.step === this.okInvestMessageIndex
      || this.step === this.investFinishMessageIndex
      || this.step === this.phoneValidatedIndex
      || this.step === this.mailValidatedIndex
      || this.step === this.acreditationConditionsIndex) {
      this.sendXHR = 'primaryDark';
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    if (this.step === this.realOwnershipDocIndex) { this.realOwnershipChecked = false }
    //if (this.step === this.enterpriseModel200DocIndex) { this.model200Checked = false }
    if (this.step < 0) {
      if (this.emailCodeIndex === 0 || this.phoneCodeIndex === 0) { } else {
        this.prevStepEvent.emit();
      }
    }
    document.getElementById('go_back').blur();
    this.prevEvent.emit();
    this.controlProgressBarSize(false);
    this.chdRef.detectChanges();
  }

  detectOS() {
    const platform = navigator.platform.toLowerCase(), iosPlatforms = ['iphone', 'ipad', 'ipod', 'ipod touch'];
    if (platform.includes('mac')) return 'MacOS';
    if (iosPlatforms.includes(platform)) return 'iOS';
    if (platform.includes('win')) return 'Windows';
    if (/android/.test(navigator.userAgent.toLowerCase())) return 'Android';
    if (/linux/.test(platform)) return 'Linux';
    this.chdRef.detectChanges();
    return 'unknown';
  }

  resetDocs() {
    this.hasConstitution1 = false;
    this.info.constitutionDocument1 = undefined;
    this.info.constitutionDocument2 = undefined;
    this.info.realOwnershipDocument = undefined;
    this.hasDocument1 = false;
    this.hasDocument2 = false;
    this.hasDocument3 = false;
    this.info.identityDocumentPartner1 = undefined;
    this.info.identityDocumentPartner2 = undefined;
    this.info.identityDocumentPartner3 = undefined;
    this.info.identityDocumentPartner4 = undefined;
    this.hasFrontDni = false;
    this.info.identityDocumentFrontRepresentative = undefined;
    this.info.identityDocumentBackRepresentative = undefined;
    this.hasFrontNie = false;
    this.info.identityDocumentFrontNieRepresentative = undefined;
    this.info.identityDocumentBackNieRepresentative = undefined;
    this.info.identityDocumentFrontPassportRepresentative = undefined;
  }

  changeWay() {
    this.changeWayEvent.emit();
  }

  onChangeAcceptRisks() { }

  canSkip() {
    return (this.step === this.companyAddressIndex
      || this.step === this.welcomeIndex
      || this.step === this.contitutionDocsIndex
      || this.step === this.realOwnershipDocIndex
      //|| this.step === this.enterpriseModel200DocIndex
      || this.step === this.identityPartnerDocsIndex
      //|| this.step === this.RLStepsIndex
      || this.step === this.RLPersonalDataIndex
      || this.step === this.RLNationalityIndex
      || this.step === this.RLDocumentTypeIndex
      || this.step === this.RLIdentityDocIndex
      || this.step === this.RLAddressDocIndex
      || this.step === this.RLSuccessIndex
      || this.step === this.phoneIndex);
  }

  acreditationSkip() {
    return (this.step === this.acreditationConditionsIndex
      || this.step === this.acreditationDocIndex
      || this.step === this.acreditationSignaturitIndex);
  }

  checkAcreditationChecked(): boolean {
    const acreditationChecks: boolean[] = [];
    if (this.cb1 === true) { acreditationChecks.push(this.cb1); }
    if (this.cb2 === true) { acreditationChecks.push(this.cb2); }
    if (this.cb3 === true) { acreditationChecks.push(this.cb3); }
    if (this.cb4 === true) { acreditationChecks.push(this.cb4); }

    return (acreditationChecks.length >= 2);
  }

  changeAcreditationConditions() {
    let chN = 0;
    this.info.accountAcreditation1000kActive = this.cb1;
    this.info.accountAcreditation2000kBusiness = this.cb2;
    this.info.accountAcreditation300kResources = this.cb3;
    this.info.accountAcreditationProfessionalAdvice = this.cb4;
    if (this.onlyAccredit) {
      this.info.accountAcreditation1000kActive ? chN++ : chN = chN;
      this.info.accountAcreditation2000kBusiness ? chN++ : chN = chN;
      this.info.accountAcreditation300kResources ? chN++ : chN = chN;
      this.info.accountAcreditationProfessionalAdvice ? chN++ : chN = chN;
      this.sendXHR = chN > 1 ? 'primaryDark' : 'primaryDark-disabled';
    }
    if (!this.cb1 && !this.cb2 && !this.cb3 && !this.cb4) {
      this.balanceDoc = false;
      this.profitsDoc = false;
      this.cnmvDoc = false;
    } else {
      if (this.cb1 || this.cb3) {
        this.balanceDoc = false;
        this.profitsDoc = true;
        this.cnmvDoc = false;
      } else {
        if (this.cb2) {
          this.balanceDoc = true;
          this.profitsDoc = false;
          this.cnmvDoc = false;
        } else {
          if (this.cb4) {
            this.balanceDoc = false;
            this.profitsDoc = false;
            this.cnmvDoc = true;
          }
        }
      }
    }
    this.chdRef.detectChanges();
  }

  finish() {
    if (this.step === this.iframeMeetingIndex
      || this.step === this.acreditationConditionsIndex
      || this.step === this.acreditationDocIndex
      || this.step === this.acreditationSignaturitIndex
      || this.step === this.phoneIndex) {
      this.finishEvent.emit();
    } else {
      if (this.step + 1 !== this.RLIdentityDocIndex && this.step + 1 !== this.iframeMeetingIndex) {
        this.step++;
      } else {
        if (this.step + 1 === this.RLIdentityDocIndex) {
          this.step = this.step + 2;
          this.sendXHR = 'primaryDark';
        } else {
          this.finishEvent.emit();
        }
      }
      if (this.step === this.investFinishMessageIndex) {
        this.checkFullProfile();
      }
    }
    this.getIdBtnName();
    //this.finishEvent.emit();
    this.chdRef.detectChanges();
  }

  onChangeAcceptTerms() {
    this.acceptPaymentEntity ? this.sendXHR = 'primaryDark' : this.sendXHR = 'primaryDark-disabled';
    this.chdRef.detectChanges();
  }

  controlFirstBtn() {
    if (this.acceptConditions && this.info.email && this.info.email !== undefined) {
      this.sendXHR = 'primaryDark';
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    this.chdRef.detectChanges();
  }
  getEmailData(value) {
    this.info.email = value.email;
    this.info.pwd = value.pwd;
    this.controlFirstBtn();
    this.chdRef.detectChanges();
  }
  getNewEmailData(value) {
    if (this.info.email !== value.email || this.info.pwd !== value.pwd) {
      this.info.email = value.email;
      this.info.pwd = value.pwd;
      this.acceptConditions = true;
      this.mailChanged = true;
    } else {
      setTimeout(() => {
        if (!this.mailChanged) {
          this.sendXHR = 'primaryDark';
          this.chdRef.detectChanges();
        }
      }, 500);
    }
    this.controlFirstBtn();
    this.chdRef.detectChanges();
  }
  getConditions(value) {
    this.info.acceptConditions = value;
    this.acceptConditions = value;
    this.controlFirstBtn();
    this.chdRef.detectChanges();
  }
  getOffers(value) {
    this.info.acceptOffers = value;
    this.chdRef.detectChanges();
  }
  getPhoneData(value) {
    this.sendXHR = 'primaryDark';
    this.info.mobile = value.pref + value.phone;
    this.info.phone = value.phone;
    this.info.prefix = value.pref;
    this.phoneNumber = this.info.prefix + this.info.phone;
    this.phoneNumberEvent.emit(this.phoneNumber);
    this.chdRef.detectChanges();
  }
  getContactPersonInfo(value) {
    this.sendXHR = 'primaryDark';
    this.info.name = value.name;
    this.info.surname = value.surname;
    this.info.birthDate = value.date;
    this.info.businessPower = value.businessPower;
    this.chdRef.detectChanges();
  }
  getCompanyData(value) {
    this.sendXHR = 'primaryDark';
    this.info.socialDenomination = value.socialDenomination;
    this.info.nif = value.nif;
    this.info.cnae = value.cnae;
    this.info.web = value.web;
    this.chdRef.detectChanges();
  }
  getCompanyAddress(value) {
    this.sendXHR = 'primaryDark';
    this.info.taxAddress = value.taxAddress;
    this.info.taxPostalCode = value.taxPostalCode;
    this.info.taxCountry = value.taxCountry;
    this.info.taxCity = value.taxCity;
    this.info.taxInternationalCity = value.taxInternationalCity;
    this.info.taxRegion = value.taxRegion;
    this.info.taxInternationalRegion = value.taxInternationalRegion;
    this.chdRef.detectChanges();
  }
  getReplegalAddress(value) {
    this.sendXHR = 'primaryDark';
    this.info.addressRepresentative = value.taxAddress;
    this.info.postalCodeRepresentative = value.taxPostalCode;
    this.info.cityRepresentative = value.taxCity;
    this.info.internationalCityRepresentative = value.taxInternationalCity;
    this.info.taxRegregionRepresentative = value.taxRegion;
    this.info.internationalRegionRepresentative = value.taxInternationalRegion;
    this.chdRef.detectChanges();
  }
  errorFile(value) {
    this.sendXHR = 'primaryDark-disabled';
    switch (value) {
      case 'constitutionDocument1':
        this.hasConstitution1 = false;
        break;
      case 'constitutionDocument2':
        break;
      case 'realOwnershipDocument':
        break;
      case 'identityDocumentPartner1':
        this.hasDocument1 = false;
        break;
      case 'identityDocumentPartner2':
        this.hasDocument2 = false;
        break;
      case 'identityDocumentPartner3':
        this.hasDocument3 = false;
        break;
      case 'identityDocumentPartner4':
        break;
      case 'RLIdentityDocumentFront':
        this.hasFrontDni = false;
        this.hasFrontNie = false;
        break;
      case 'RLIdentityDocumentBack':
        break;
      case 'RLAddressDocument':
        break;
      case 'acreditationDoc':
        break;
    }
    this.chdRef.detectChanges();
  }
  getConstitutionDocument1(value) {
    if (value) {
      this.sendXHR = 'primaryDark';
      this.info.constitutionDocument1 = value;
      this.hasConstitution1 = true;
    } else {
      this.sendXHR = 'primaryDark-disabled';
      this.info.constitutionDocument1 = undefined;
      this.hasConstitution1 = false;
    }
    this.chdRef.detectChanges();
  }
  getConstitutionDocument2(value) {
    value ? this.info.constitutionDocument2 = value : this.info.constitutionDocument2 = undefined;
    this.chdRef.detectChanges();
  }
  getRealOwnershipDocument(value) {
    if (value) {
      this.info.realOwnershipDocument = value;
    }
    if (value && this.realOwnershipChecked) {
      this.sendXHR = 'primaryDark';
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    this.chdRef.detectChanges();
  }
  checkedRealOwnershipDocument() {
    if (this.realOwnershipChecked && this.info.realOwnershipDocument) {
      this.sendXHR = 'primaryDark';
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    this.chdRef.detectChanges();
  }
  getModel200Document(value) {
    if (value) {
      this.info.enterpriseModel200 = value;
    }
    if (value && this.model200Checked) {
      this.sendXHR = 'primaryDark';
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    this.chdRef.detectChanges();
  }
  checkedModel200Document() {
    if (this.model200Checked && this.info.enterpriseModel200) {
      this.sendXHR = 'primaryDark';
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    this.chdRef.detectChanges();
  }
  getIdentityDocumentPartner1(value) {
    if (value) {
      this.sendXHR = 'primaryDark';
      this.info.identityDocumentPartner1 = value;
      this.hasDocument1 = true;
    } else {
      this.sendXHR = 'primaryDark-disabled';
      this.info.identityDocumentPartner1 = undefined;
      this.hasDocument1 = false;
    }
    this.chdRef.detectChanges();
  }
  getIdentityDocumentPartner2(value) {
    if (value) {
      this.info.identityDocumentPartner2 = value;
      this.hasDocument2 = true;
    } else {
      this.info.identityDocumentPartner2 = undefined;
      this.hasDocument2 = false;
    }
    this.chdRef.detectChanges();
  }
  getIdentityDocumentPartner3(value) {
    if (value) {
      this.info.identityDocumentPartner3 = value;
      this.hasDocument3 = true;
    } else {
      this.info.identityDocumentPartner3 = undefined;
      this.hasDocument3 = false;
    }
    this.chdRef.detectChanges();
  }
  getIdentityDocumentPartner4(value) {
    value ? this.info.identityDocumentPartner4 = value : this.info.identityDocumentPartner4 = undefined;
    this.chdRef.detectChanges();
  }
  getRLData(value) {
    this.sendXHR = 'primaryDark';
    this.info.nameRepresentative = value.nameRepresentative;
    this.info.surnameRepresentative = value.surnameRepresentative;
    this.info.birthDateRepresentative = value.birthDateRepresentative;
    this.info.actAsRepresentative = value.actAsRepresentative;
    this.chdRef.detectChanges();
  }
  getRLNationality(value) {
    this.sendXHR = 'primaryDark';
    this.info.nationalityRepresentative = value.nationalityRepresentative;
    this.info.countryRepresentative = value.countryRepresentative;
    this.chdRef.detectChanges();
  }
  getRLDocType(value) {
    this.sendXHR = 'primaryDark';
    this.info.identityDocumentTypeRepresentative = Number(value.identityDocumentTypeRepresentative);
    switch (Number(value.identityDocumentTypeRepresentative)) {
      case 1:
        this.info.identityDocumentDniRepresentative = value.identityDocumentNumberRepresentative;
        break;
      case 2:
        this.info.identityDocumentNieRepresentative = value.identityDocumentNumberRepresentative;
        break;
      case 3:
        this.info.identityDocumentPassportRepresentative = value.identityDocumentNumberRepresentative;
        break;
    }
    this.chdRef.detectChanges();
  }
  getRLIdentityDocumentFront(value) {
    if (value) {
      this.sendXHR = 'primaryDark';
      if (this.info.identityDocumentDniRepresentative) {
        this.info.identityDocumentFrontRepresentative = value;
        this.hasFrontDni = true;
      } else {
        this.info.identityDocumentFrontRepresentative = '';
        this.hasFrontDni = false;
      }
      if (this.info.identityDocumentNieRepresentative) {
        this.info.identityDocumentFrontNieRepresentative = value;
        this.hasFrontNie = true;
      } else {
        this.info.identityDocumentFrontNieRepresentative = '';
        this.hasFrontNie = false;
      }
      if (this.info.identityDocumentPassportRepresentative) {
        this.info.identityDocumentFrontPassportRepresentative = value;
      } else {
        this.info.identityDocumentFrontPassportRepresentative = '';
      }
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    this.chdRef.detectChanges();
  }
  getRLIdentityDocumentBack(value) {
    if (this.info.identityDocumentDniRepresentative) {
      this.info.identityDocumentBackRepresentative = value;
    } else {
      this.info.identityDocumentBackRepresentative = '';
    }
    if (this.info.identityDocumentNieRepresentative) {
      this.info.identityDocumentBackNieRepresentative = value;
    } else {
      this.info.identityDocumentBackNieRepresentative = '';
    }
    this.chdRef.detectChanges();
  }
  getRLAddressDocument(value) {
    if (value) {
      this.sendXHR = 'primaryDark';
      this.info.addressVerifyRepresentative = value;
    } else {
      this.sendXHR = 'primaryDark-disabled';
      this.info.addressVerifyRepresentative = '';
    }
    this.chdRef.detectChanges();
  }
  getAcreditationConditions(value) {
    this.sendXHR = 'primaryDark';
    this.info.accountAcreditation1000kActive = value.accountAcreditation1000kActive;
    this.info.accountAcreditation2000kBusiness = value.accountAcreditation2000kBusiness;
    this.info.accountAcreditation300kResources = value.accountAcredtation300kResources;
    this.info.accountAcreditationProfessionalAdvice = value.accountAcreditationProfessionalAdvice;
    this.chdRef.detectChanges();
  }
  getAcreditationDocument(value) {
    if (value) {
      this.sendXHR = 'primaryDark';
      this.acreditationDocument = value;
    } else {
      this.sendXHR = 'primaryDark-disabled';
      this.acreditationDocument = '';
    }
    this.chdRef.detectChanges();
  }
  getError() {
    setTimeout(() => {
      this.sendXHR = 'primaryDark-disabled';
      this.chdRef.detectChanges();
    }, 50);
    this.chdRef.detectChanges();
  }
  public isLoading(value) {
    this.loading = value;
    this.chdRef.detectChanges();
  }
  getCodeInfo(value) {
    if (
      (value.code1 !== null && value.code1 !== '') &&
      (value.code2 !== null && value.code2 !== '') &&
      (value.code3 !== null && value.code3 !== '') &&
      (value.code4 !== null && value.code4 !== '') &&
      (value.code5 !== null && value.code5 !== '') &&
      (value.code6 !== null && value.code6 !== '')
    ) {
      this.sendXHR = 'primaryDark';
      this.info.code =
        value.code1.toString() + value.code2.toString() + value.code3.toString() +
        value.code4.toString() + value.code5.toString() + value.code6.toString();
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    this.chdRef.detectChanges();
  }
  editMail() {
    this.editM = true;
    this.prev();
    this.chdRef.detectChanges();
  }

  editPhone() {
    this.prev();
    this.chdRef.detectChanges();
  }

  okSimpleCopy() {
    this.uploadSimpleCopy = true;
    this.chdRef.detectChanges();
  }

  resendCode(value) {
    this.resended = true;
    this.resendCodeEvent.emit(value);
    this.chdRef.detectChanges();
  }

  getSignaturitUrl() {
    this.signaturitAccreditEvent.emit();
    this.chdRef.detectChanges();
  }

  public setSignaturitUrl(url) {
    this.signaturitUrl = url;
    if (this.step === this.acreditationSignaturitIndex) {
      this.registerIfameComponent.startSign(url);
    }
    //this.registerIfameComponent.startSign(url);
    this.chdRef.detectChanges();
  }

  continueInvest() {
    this.continueInvestEvent.emit();
    this.chdRef.detectChanges();
  }

  hasFooter() {
    if (this.step === this.onBoardingIndex
      || this.step === this.emailIndex
      || this.step === this.emailCodeIndex
      || this.step === this.mailValidatedIndex
      || this.step === this.phoneIndex
      || this.step === this.phoneCodeIndex
      || this.step === this.phoneValidatedIndex
      || this.step === this.contactPersonDataIndex
      || this.step === this.companyDataIndex
      || this.step === this.companyAddressIndex
      || this.step === this.welcomeIndex
      || this.step === this.contitutionDocsIndex
      || this.step === this.realOwnershipDocIndex
      //|| this.step === this.enterpriseModel200DocIndex
      || this.step === this.identityPartnerDocsIndex
      //|| this.step === this.RLStepsIndex
      || this.step === this.RLPersonalDataIndex
      || this.step === this.RLNationalityIndex
      || this.step === this.RLDocumentTypeIndex
      || this.step === this.RLIdentityDocIndex
      || this.step === this.RLIdentityDocAdviceIndex
      || this.step === this.RLAddressDocIndex
      || this.step === this.RLSuccessIndex
      || this.step === this.acreditationConditionsIndex
      || this.step === this.acreditationDocIndex
      || this.step === this.RLPersonalAddressIndex
      || this.step === this.identityPartnerSpecificDocsIndex
      || this.step === this.partnersIndex
      || this.step === this.partnersAddressIndex
      || this.step === this.partnersNationalityIndex
        /* || this.step === this.successCompleteRegisterIndex */
        /* || this.step === this.iframeMeetingIndex */) {
      return true;
    }
    return false;
  }

  getIdBtnName() {
    let name;
    if (this.list[this.step] && this.list[this.step].name && this.list[this.step].name !== undefined) {
      name = this.list[this.step].name;
    } else {
      name = '';
    }

    switch (name) {
      case 'email':
        this.personalId = 'pj_sign_up';
        break;
      case 'emailCode':
        this.personalId = 'pj_email_validation';
        break;
      case 'phoneCode':
        this.personalId = 'pj_sms_validation';
        break;
      case 'phone':
        this.personalId = 'pj_mobile_phone';
        break;
      case 'contactPersonData':
        this.personalId = 'pj_contact_info';
        break;
      case 'companyData':
        this.personalId = 'pj_company_info';
        break;
      case 'companyAddress':
        this.personalId = 'pj_company_address';
        break;
      case 'welcome':
        this.personalId = 'pj_msg_wel';
        break;
      case 'constitutionDocs':
        this.personalId = 'pj_company_inc';
        break;
      case 'realOwnershipDoc':
        this.personalId = 'pj_company_ownership';
        break;
      case 'model200Doc':
        this.personalId = 'pj_model200_doc';
        break;
      case 'identityPartnerDocs':
        this.personalId = 'pj_company_owner_id';
        break;
      case 'RLSteps':
        this.personalId = 'pj_company_documents';
        break;
      case 'RLPersonalData':
        this.personalId = 'pj_legal_rep_info';
        break;
      case 'RLNationality':
        this.personalId = 'pj_legal_rep_citizenship';
        break;
      case 'RLDocumentType':
        this.personalId = 'pj_legal_rep_id';
        break;
      case 'RLIdentityDoc':
        this.personalId = 'pj_legal_rep_document';
        break;
      case 'RLAddressDoc':
        this.personalId = 'pj_legal_rep_address';
        break;
      case 'RLSuccess':
        this.personalId = 'pj_accreditation_request';
        break;
      case 'acreditationConditions':
        this.personalId = 'pj_accreditation_conditions';
        break;
      case 'acreditationDoc':
        this.personalId = 'pj_accreditation_documents';
        break;
      case 'acreditationSignaturit':
        this.personalId = 'pj_acreditation_sign';
        break;
      case 'successCompleteRegister':
        if (this.incompleteProfile) {
          this.personalId = 'pj_incomplete_profile';
          this.personalSpan = this.translate.instant('REGISTER.PROFILE_COMPLETE');
        } else {
          this.personalId = 'pj_full_profile';
          this.personalSpan = this.translate.instant('REGISTER.PROFILE_INCOMPLETE');
        }
        break;
      default:
        this.personalId = '';
    }
    this.chdRef.detectChanges();
  }

  controlProgressBarSize(increase) {
    if (increase) {
      this.percent = this.percent + (100 / this.stepNumber);
    } else {
      this.percent = this.percent - (100 / this.stepNumber);
    }
    this.percent = (this.percent <= 100) ? this.percent : 100;
    this.chdRef.detectChanges();
  }

  checkRefCode(code) {
    this.refCode = code;
    this.checkRefCodeEvent.emit(code);
    this.chdRef.detectChanges();
  }

  public setRefUsername(username) {
    this.refCode = username !== undefined ? this.refCode : undefined;
    this.registerPersonEmail.setRefUsername(username);
    this.chdRef.detectChanges();
  }

  generateProfile() {
    this.loading = true;
    const model = {
      profileType: 2,
      username: this.info.email !== null && this.info.email !== undefined ? this.info.email : this.profile.username,
      name: this.info.name,
      surname: this.info.surname,
      birthDate: this.info.birthDate.replace('-', '/').replace('-', '/'),
      businessPower: this.info.businessPower,
      socialDenomination: this.info.socialDenomination,
      nif: this.info.nif,
      cnae: this.info.cnae,
      web: this.info.web
    };
    this.profileService.generateProfile(model).subscribe(response => {
      this.loading = false;
      //this.updateData({acceptPaymentEntity: true});
      this.storage.set('NAME', response.name);
      this.storage.set('PROFILE', response);
      this.profilegeneratedEvent.emit();
      this.posthogService.pushEvent('user_profile_generated');
      this.dataLayerService.pushCustomEventGTM('register_profile_generated');
      this.chdRef.detectChanges();
    }, (error) => {
      const msg = this.translate.instant('REGISTER.ERROR_CREATE_PROOFILE');
      this.loading = false;
      this.prev();
      this.toastService.showToast(msg, 'warning', true);
      this.chdRef.detectChanges();
    });
  }

  checkEmptyValue(value) {
    return (value === null || value === undefined || value === '') ? true : false;
  }

  updateData(model, finish?: boolean) {
    this.profileService.updateProfile(model).subscribe(resp => {
      this.profile = resp;
      this.loading = false;
      if (finish) {
        this.finishEvent.emit();
      }
      this.chdRef.detectChanges();
    }, error => {
      this.prev();
      this.loading = false;
      this.chdRef.detectChanges();
    })
  }

  showTermsAndConditions(value) {
    this.emailPage = value;
    this.chdRef.detectChanges();
  }

  checkMangopayTerms(value) {
    this.mangopayTerms = value;
    if (this.mangopayTerms) {
      this.sendXHR = 'primaryDark';
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }
    this.chdRef.detectChanges();
  }

  checkFullProfile() {
    this.loading = true;
    this.overviewService.getWalletStatus().subscribe(() => {
      this.loading = false;
      this.chdRef.detectChanges();
    }, error => {
      this.textF = this.translate.instant('MESSAGES.BAD_PROFILE_1');
      this.imageM = 15;
      this.loading = false;
      this.chdRef.detectChanges();
    })
    this.chdRef.detectChanges();
  }

  setSpecificDocumentOwner(value) {
    this.specificDocumentOwner = value;
    this.sendXHR = 'primaryDark';
    this.chdRef.detectChanges();
  }

  deleteSpecificDocumentOwner() {
    this.specificDocumentOwner = undefined;
    this.sendXHR = 'primaryDark-disabled';
    this.chdRef.detectChanges();
  }

  updateSpecificDocumentOwner() {
    this.loading = true;
    //this.specificDocumentOwner
    //specificPartner
    this.profileService.uploadFile(this.specificDocumentOwner).subscribe(res => {
      let model: any;
      switch (this.specificPartner) {
        case 'identityDocumentPartner1':
          model = { identityDocumentPartner1: res.fileID };
          break;
        case 'identityDocumentPartner2':
          model = { identityDocumentPartner2: res.fileID };
          break;
        case 'identityDocumentPartner3':
          model = { identityDocumentPartner3: res.fileID };
          break;
        case 'identityDocumentPartner4':
          model = { identityDocumentPartner4: res.fileID };
          break;
      }
      this.updateData(model, true);
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  removeModal() {
    this.removeModalEvent.emit();
    this.chdRef.detectChanges();
  }

  checkPartnersData(value: any) {
    if (value['valid']) {
      const newData = value.data;

      // Asegurar que el array tiene suficientes elementos
      while (this.partners.length <= this.partnersNumber) {
        this.partners.push({});
      }

      // Obtener el objeto en la posición indicada por partnersNumber
      let targetObj = this.partners[this.partnersNumber];

      // Actualizar o añadir las variables del nuevo objeto
      for (const key of Object.keys(newData)) {
        targetObj[key] = newData[key];
      }

      this.sendXHR = 'primaryDark';
    } else {
      this.sendXHR = 'primaryDark-disabled';
    }

    this.chdRef.detectChanges();
  }

  controlPartnersData(index) {
    if (index === 1) {
      this.step = this.partnersIndex;
      this.partnersNumber++;
      if (this.partnersNumber >= 3) {
        this.partnersText = this.translate.instant('REGISTER.PARTNERS_ADDED_ALL');
        this.partnersBtnList = [{
          type: 'primaryDark',
          index: 2,
          title: 'Finalizar',
        }];
      }
    } else {
      this.loading = true;
      this.updateData({ partners: this.partners });
      this.step++;
    }
    this.chdRef.detectChanges();
  }

  editPartners() {
    this.step = this.partnersIndex;
    this.chdRef.detectChanges();
  }

}
